// extracted by mini-css-extract-plugin
export default {"wrapper":"Alert_wrapper__tuLxV","root":"Alert_root__DL5U1","icon":"Alert_icon__owVYL","error":"Alert_error__TWZmC","warning":"Alert_warning__u54nJ"};